exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host{\t\t\t\r\n  width: 100%;\r\n  height: 400px;\r\n  background: #C9CBB6;    display: block;\r\n}\r\n\r\n.loadpage{\r\n  display: table-cell;\r\n}\r\n\r\nimg{ \r\n  position: absolute; \r\n  top: 0;  \r\n  bottom: 0;  \r\n  left: 0;  \r\n  right: 0;  \r\n  margin: auto;   \r\n}\r\n\r\n@media (max-width: 480px){\r\n  :host{\t\t\t\r\n    width: 100%;\r\n    height: 300px;\r\n    background: #C9CBB6;    display: block;\r\n  }\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/loading/loading.component.css
// module id = 628
// module chunks = 8